import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Organizing from '@/components/organizing'
import Committee from '@/components/committee'
import CallPapers from '@/components/callPapers'
import Session from '@/components/session'
import Schedule from '@/components/schedule'
import Program from '@/components/program'
import Submissions from '@/components/submissions'
import Submissions2 from '@/components/submissions2'
import Visa from '@/components/visa'
import Travel from '@/components/travel'
import Speakers from '@/components/speakers'
import Sponsors from '@/components/sponsors'
import Awards from '@/components/awards'
import Contact from '@/components/contact'
import Reg from '@/components/reg'
import Login from '@/components/login'
import Register1 from '@/components/register1'
import Register2 from '@/components/register2'
import Register3 from '@/components/register3'
import newsDetail from '@/components/newsDetail'
import newsDetail1 from '@/components/newsDetail1'
import newsDetail3 from '@/components/newsDetail3'
import newsDetail4 from '@/components/newsDetail4'
import newsDetail5 from '@/components/newsDetail5'
import newsDetail6 from '@/components/newsDetail6'
import newsDetail7 from '@/components/newsDetail7'
import newsDetail8 from '@/components/newsDetail8'
import newList from '@/components/newList'
import loginThen from '@/components/loginThen'
import uploadPaper from '@/components/uploadPaper'
import uploadPaperDetail from '@/components/uploadPaperDetail'
import submitPaper from '@/components/submitPaper'
import registration from '@/components/registration'
import payment from '@/components/payment'
import submissionUpload from '@/components/submissionUpload'
import subUpThen from '@/components/subUpThen'
import simpleReg from '@/components/simpleReg'
import bank from '@/components/bank'
import traveltwo from '@/components/traveltwo'
import hotel from '@/components/hotel'
import letter from '@/components/letter'
import loginThenTest from '@/components/loginThenTest'
import registerView from '@/components/registerView'
import organizingtest from '@/components/organizingtest'
import callforPapers from '@/components/callforPapers'
import organizingCommittees from '@/components/organizingCommittees'


Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'index',
		component: Index,
	}, {
		path: '/organizingtest',
		name: 'organizingtest',
		component: organizingtest
	}, {
		path: '/organizingCommittees',
		name: 'organizingCommittees',
		component: organizingCommittees
	}, {
		path: '/callforPapers',
		name: 'callforPapers',
		component: callforPapers
	}, {
		path: '/newsDetail6',
		name: 'newsDetail6',
		component: newsDetail6
	}, {
		path: '/newsDetail7',
		name: 'newsDetail7',
		component: newsDetail7
	}, {
		path: '/newList',
		name: 'newList',
		component: newList
	}, {
		path: '/newsDetail8',
		name: 'newsDetail8',
		component: newsDetail8
	}, {
		path: '/registerView',
		name: 'registerView',
		component: registerView
	}, {
		path: '/loginThenTest',
		name: 'loginThenTest',
		component: loginThenTest
	}, {
		path: '/organizing',
		name: 'organizing',
		component: Organizing
	}, {
		path: '/committee',
		name: 'committee',
		component: Committee
	}, {
		path: '/callPapers',
		name: 'callPapers',
		component: CallPapers
	}, {
		path: '/session',
		name: 'session',
		component: Session

	}, {
		path: '/schedule',
		name: 'schedule',
		component: Schedule
	}, {
		path: '/program',
		name: 'program',
		component: Program
	}, {
		path: '/submissions',
		name: 'submissions',
		component: Submissions
	}, {
		path: '/importantDates',
		name: 'submissions2',
		component: Submissions2
	}, {
		path: '/visa',
		name: 'visa',
		component: Visa
	}, {
		path: '/travel',
		name: 'travel',
		component: Travel
	}, {
		path: '/speakers',
		name: 'speakers',
		component: Speakers
	}, {
		path: '/sponsors',
		name: 'sponsors',
		component: Sponsors
	}, {
		path: '/awards',
		name: 'awards',
		component: Awards
	}, {
		path: '/contact',
		name: 'contact',
		component: Contact
	}, {
		path: '/reg',
		name: 'reg',
		component: Reg
	}, {
		path: '/register1',
		name: 'register1',
		component: Register1
	}, {
		path: '/register2',
		name: 'register2',
		component: Register2
	}, {
		path: '/register3',
		name: 'register3',
		component: Register3
	}, {
		path: '/login',
		name: 'login',
		component: Login
	}, {
		path: '/newsDetail',
		name: 'newsDetail',
		component: newsDetail
	}, {
		path: '/newsDetail1',
		name: 'newsDetail1',
		component: newsDetail1
	}, {
		path: '/newsDetail3',
		name: 'newsDetail3',
		component: newsDetail3
	}, {
		path: '/newsDetail4',
		name: 'newsDetail4',
		component: newsDetail4
	}, {
		path: '/newsDetail5',
		name: 'newsDetail5',
		component: newsDetail5
	}, {
		path: '/loginThen',
		name: 'loginThen',
		component: loginThen
	}, {
		path: '/uploadPaper',
		name: 'uploadPaper',
		component: uploadPaper
	}, {
		path: '/uploadPaperDetail',
		name: 'uploadPaperDetail',
		component: uploadPaperDetail
	}, {
		path: '/submitPaper',
		name: 'submitPaper',
		component: submitPaper
	}, {
		path: '/registration',
		name: 'registration',
		component: registration
	}, {
		path: '/payment',
		name: 'payment',
		component: payment
	}, {
		path: '/uploadPaper',
		name: 'uploadPaper',
		component: uploadPaper
	}, {
		path: '/submissionUpload',
		name: 'submissionUpload',
		component: submissionUpload
	}, {
		path: '/subUpThen',
		name: 'subUpThen',
		component: subUpThen
	}, {
		path: '/simpleReg',
		name: 'simpleReg',
		component: simpleReg
	}, {
		path: '/bank',
		name: 'bank',
		component: bank
	}, {
		path: '/hotel',
		name: 'hotel',
		component: hotel
	}, {
		path: '/traveltwo',
		name: 'traveltwo',
		component: traveltwo
	}, {

		path: '/letter',
		name: 'letter',
		component: letter
	}],
})


// WEBPACK FOOTER //
// ./src/router/index.js